export default __webpack_public_path__ + "static/media/werdle.ab5181d0.png";